import "../../../styles/typography.css";
import "./Button.css"; 

const Button = ({ 
  children, 
  variant = "active", // "active" | "disabled" | "outlined" | "edit-active" | "edit-disabled" | "tab-btn"
  size = "md",       // "sm" | "md" | "lg"
  className = "", 
  ...rest 
}) => {
  const getVariantClass = () => {
    switch (variant) {
      case "disabled":
        return "disabled-btn";
      case "outlined":
        return "outlined-active-btn";
      case "edit-active":
        return "edit-active-btn"; 
      case "edit-disabled":
        return "edit-disabled-btn";
      case "tab-btn":
        return "tab-btn";
      default:
        return "active-btn";
    }
  };

  const getSizeClass = () => {
    switch (size) {
      case "sm":
        return "btn-sm";
      case "lg":
        return "btn-lg";
      default:
        return "btn-md";
    }
  };

  return (
    <button
      type="button"
      className={`btn-common ${getVariantClass()} ${getSizeClass()} default-font-styles ${className}`}
      disabled={variant === "disabled"}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
